module.exports = __webpack_public_path__ + "img/addImage.408d8f37.png";